import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ControlGroup, Intent, NumericInput } from '@blueprintjs/core';

const EventDateInput = props => {
  const handleChange = value => {
    props.onChange({ ...props.value, ...value });
  };

  const [validMonth, setValidMonth] = useState(true);
  const handleChangeMonth = value => {
    if (typeof value === 'number') {
      if (value >= 1) {
        setValidMonth(true);
        handleChange({ m: Math.min(value, 12) });
        return;
      }
    }
    setValidMonth(false);
    handleChange({ m: undefined });
  };

  const [validDay, setValidDay] = useState(true);
  const handleChangeDay = value => {
    if (typeof value === 'number') {
      if (value >= 1) {
        setValidDay(true);
        handleChange({ d: Math.min(value, 31) });
        return;
      }
    }
    setValidDay(false);
    handleChange({ d: undefined });
  };

  const [validYear, setValidYear] = useState(true);
  const handleChangeYear = value => {
    if (typeof value === 'number') {
      if (value >= 1) {
        setValidYear(value >= 1000 && value <= 9999);
        handleChange({ y: Math.min(value, 9999) });
        return;
      }
    }
    setValidYear(false);
    handleChange({ y: undefined });
  };

  return (
    <ControlGroup>
      <NumericInput
        value={props.value.m ?? ''}
        placeholder="MM"
        style={{ height: 30, width: 44 }}
        buttonPosition="none"
        onValueChange={handleChangeMonth}
        minorStepSize={1}
        majorStepSize={1}
        intent={validMonth ? Intent.NONE : Intent.DANGER}
        autoComplete="off"
      />

      <NumericInput
        value={props.value.d ?? ''}
        placeholder="DD"
        style={{ height: 30, width: 44 }}
        buttonPosition="none"
        onValueChange={handleChangeDay}
        minorStepSize={1}
        majorStepSize={1}
        intent={validDay ? Intent.NONE : Intent.DANGER}
        autoComplete="off"
      />

      <NumericInput
        value={props.value.y ?? ''}
        placeholder="YYYY"
        style={{ height: 30, width: 55 }}
        buttonPosition="none"
        onValueChange={handleChangeYear}
        minorStepSize={1}
        majorStepSize={1}
        intent={validYear ? Intent.NONE : Intent.DANGER}
        autoComplete="off"
      />
    </ControlGroup>
  );
};

EventDateInput.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
};

EventDateInput.defaultProps = {
  value: {},
};

export default EventDateInput;
